// Bootstrap pattern for Module Federation
// This file must remain minimal and not import any shared modules directly
// All application code is loaded asynchronously in bootstrap.tsx

import('./bootstrap').catch((err) => {
  console.error('Failed to load application bootstrap:', err);
});
